<template>
  <div class="home_wrap">
    <van-row class="topSection">
      <van-col span="4" style="text-align: left">
        <img
          src="../images/common/backArrow.png"
          @click="$router.back()"
          class="imageback"
        />
      </van-col>
      <van-col span="20" style="text-align: right">
        <span style="color: #ffffff; font-size: 30px; font-weight: 700">{{
          $t("setpaypwd.modifyPaymentPassword")
        }}</span>
      </van-col>
    </van-row>
    <div class="wrap">
      <div class="title">
        <p style="color: #ffffff">
          {{ $t("setpaypwd.setNewPaymentPassword") }}
        </p>
        <div class="cut" v-if="!codeStatus" @click="cutType(1)">
          {{ $t("setpwd.usemobilenumber") }}
        </div>
      </div>
      <p class="bd_tel" v-if="codeStatus">
        {{ $t("setpwd.boundmobilenumber") }}{{ ycmobile }}
      </p>

      <div v-if="codeStatus">
        <van-row style="margin-top: 15px">
          <van-col span="24"
            ><p class="labelText">
              {{ $t("setpwd.SMSverificationcode") }}:
            </p></van-col
          >
        </van-row>
        <div class="item">
          <span class="icon"
            ><img src="../images/register/OTP.png" alt=""
          /></span>
          <input type="number" v-model="code" />
          <van-count-down :time="time" class="btn get_code" @finish="timeCall">
            <template v-slot="timeData">
              <span @click="sendcode">{{
                timeData.seconds > 0 ? timeData.seconds : $t("setpwd.sendcode")
              }}</span>
            </template>
          </van-count-down>
        </div>
      </div>

      <!-- ---------- if no code add current password ------ -->
      <div v-if="!codeStatus">
        <van-row style="margin-top: 15px">
          <van-col span="24"
            ><p class="labelText">
              {{ $t("setpaypwd.loginpassword") }}:
            </p></van-col
          >
        </van-row>
        <div class="item">
          <span class="icon"
            ><img src="../images/register/password.png" alt=""
          /></span>
          <input :type="passwordInp" v-model="password" />
          <div
            class="eye_bi"
            @click="showPwd"
            :class="passwordInp == 'text' ? 'eye' : ''"
          ></div>
        </div>
      </div>

      <!-- ---------- new password ------ -->
      <van-row style="margin-top: 15px">
        <van-col span="24"
          ><p class="labelText">{{ $t("setpaypwd.loginpassword") }}:</p></van-col
        >
      </van-row>
      <div class="item">
        <span class="icon"
          ><img src="../images/register/password.png" alt=""
        /></span>
        <input :type="newpasswordInp" v-model="npassword" />
        <div
          class="eye_bi"
          @click="showNewsPwd"
          :class="newpasswordInp == 'text' ? 'eye' : ''"
        ></div>
      </div>

      <!-- ---------- re enter new password ------ -->
      <van-row style="margin-top: 15px">
        <van-col span="24"
          ><p class="labelText">
            {{ $t("setpwd.confirmnewpassword") }}:
          </p></van-col
        >
      </van-row>
      <div class="item">
        <span class="icon"
          ><img src="../images/register/password.png" alt=""
        /></span>
        <input :type="newpasswordInp" v-model="rpassword" />
        <div
          class="eye_bi"
          @click="showNewsPwd"
          :class="newpasswordInp == 'text' ? 'eye' : ''"
        ></div>
      </div>
      <van-row>
        <van-col span="24">
          <div
            v-if="codeStatus"
            class="confirm_btn"
            :class="
              rpassword != '' && code != '' && npassword != '' ? '' : 'no_touch'
            "
            @click="dxRevise"
          >
            {{ $t("setpwd.modify") }}
          </div>
          <div
            v-if="!codeStatus"
            class="confirm_btn"
            :class="
              password != '' && rpassword != '' && npassword != ''
                ? ''
                : 'no_touch'
            "
            @click="oldRevise"
          >
            {{ $t("setpwd.modify") }}
          </div>
        </van-col>
      </van-row>
    </div>
    <!-- <van-popup
      v-model="write_psd"
      closeable
      close-icon="close"
      round
      position="bottom"
    >
      <div class="psw_box">
        <van-password-input
          :value="psd_val"
          :mask="true"
          :focused="showKeyboard"
          @focus="showKeyboard = true"
        />
        <div class="keybord_box">
          <div class="keybord">
            <div class="key_item" @click="onInput(1)">
              <div class="key_inner">1</div>
            </div>
            <div class="key_item" @click="onInput(2)">
              <div class="key_inner">2</div>
            </div>
            <div class="key_item" @click="onInput(3)">
              <div class="key_inner">3</div>
            </div>
            <div class="key_item" @click="onInput(4)">
              <div class="key_inner">4</div>
            </div>
            <div class="key_item" @click="onInput(5)">
              <div class="key_inner">5</div>
            </div>
            <div class="key_item" @click="onInput(6)">
              <div class="key_inner">6</div>
            </div>
            <div class="key_item" @click="onInput(7)">
              <div class="key_inner">7</div>
            </div>
            <div class="key_item" @click="onInput(8)">
              <div class="key_inner">8</div>
            </div>
            <div class="key_item" @click="onInput(9)">
              <div class="key_inner">9</div>
            </div>
            <div class="key_item no_bg"><div class="key_inner"></div></div>
            <div class="key_item" @click="onInput(0)">
              <div class="key_inner">0</div>
            </div>
            <div class="key_item no_bg x" @click="onDelete">
              <div class="key_inner">x</div>
            </div>
          </div>
        </div>
      </div>
    </van-popup> -->
  </div>
</template>

<script>
import Vue from "vue";
import { CountDown } from "vant";
import Fetch from "../../utils/fetch";

import { Popup } from "vant";
import { PasswordInput, NumberKeyboard, Row, Col } from "vant";

Vue.use(PasswordInput);
Vue.use(NumberKeyboard);
Vue.use(Popup);
Vue.use(CountDown).use(Row).use(Col);

export default {
  name: "setpwd",
  data() {
    return {
      time: 0,
      password: "",
      rpassword: "",
      npassword: "",
      mobile: "",
      ycmobile: "",
      passwordInp: "password",
      newpasswordInp: "password",
      codeStatus: true,
      code: "",
      is_send: false,
      // nowInput: 1,
      // psd_val: "",
      // codeOK: false,
      // showKeyboard: true,
      // choose_tick: false,
      // write_psd: false,
    };
  },
  mounted() {
    Fetch("/user/info").then((r) => {
      this.mobile = r.data.mobile;
      this.ycmobile = r.data.mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
    });
  },
  methods: {
    // showWord(n) {
    //   n == 1 ? (this.nowInput = 1) : (this.nowInput = 2);
    //   this.psd_val = "";
    //   this.write_psd = true;
    // },
    // onInput(key) {
    //   this.psd_val = (this.psd_val + key).slice(0, 6);
    //   if (this.psd_val.length == 6) {
    //     if (this.nowInput == 1) {
    //       this.npassword = this.psd_val;
    //     } else {
    //       this.rpassword = this.psd_val;
    //     }
    //     this.write_psd = false;
    //   }
    // },
    // onDelete() {
    //   this.psd_val = this.psd_val.slice(0, this.psd_val.length - 1);
    // },
    cutType(n) {
      n == 1 ? (this.codeStatus = true) : (this.codeStatus = false);
      this.rpassword = "";
      this.npassword = "";
    },
    timeCall() {
      this.is_send = false;
      this.time = 0;
    },
    sendcode() {
      if (this.is_send) {
        return;
      }

      this.is_send = true;

      Fetch("/user/modify_code", {
      })
        .then(() => {
          this.time = 60 * 1000;
          this.$toast({
            background: "#07c160",
            message: this.$t("setpwd.sendsuccessfully"),
          });
        })
        .catch(() => {
          this.is_send = false;
        });
    },
    showPwd() {
      this.passwordInp == "password"
        ? (this.passwordInp = "text")
        : (this.passwordInp = "password");
    },
    showNewsPwd() {
      this.newpasswordInp == "password"
        ? (this.newpasswordInp = "text")
        : (this.newpasswordInp = "password");
    },
    dxRevise() {
      if (!this.npassword) {
        this.$toast(this.$t("setpaypwd.newpasswordcannotbeempty"));
        return false;
      }

      if (this.npassword !== this.rpassword) {
        this.$toast(this.$t("setpaypwd.inconsistent"));
        return false;
      }

      Fetch("/user/changePayPassSms", {
        code: this.code,
        pass: this.npassword,
      }).then(() => {
        this.$toast({
          background: "#07c160",
          message: this.$t("setpwd.modifiedsuccessfully"),
        });

        // sessionStorage.setItem("pwd", this.npassword);

        if (this.$route.query.redirect) {
          this.$router.replace(this.$route.query.redirect + "?change");
        } else {
          this.$router.go(-1);
        }
      });
    },
    oldRevise() {
      if (!this.password) {
        this.$toast(this.$t("setpaypwd.loginpasswordcannotbeempty"));
        return false;
      }

      if (!this.npassword) {
        this.$toast(this.$t("setpaypwd.newpasswordcannotbeempty"));
        return false;
      }

      if (this.npassword !== this.rpassword) {
        this.$toast(this.$t("setpaypwd.inconsistent"));
        return false;
      }
      var reg = new RegExp("^[0-9]*$");
      if (!reg.test(this.npassword)) {
        this.$toast(this.$t("setpaypwd.pureNumber"));
        return false;
      }
      if (!reg.test(this.rpassword)) {
        this.$toast(this.$t("setpaypwd.pureNumber"));
        return false;
      }
      Fetch("/user/resetpaypwd", {
        passwd: this.password,
        npasswd: this.npassword,
      }).then(() => {
        this.$toast({
          background: "#07c160",
          message: this.$t("setpwd.modifiedsuccessfully"),
        });

        this.$router.replace("/safe");
      });
    },
  },
};
</script>

<style lang="less" scoped>
.home_wrap {
  width: 100%;
  min-height: 100vh;
  background: url("../images/common/BgImg.png");
  background-size: 100% 100%;
}

.topSection {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 30px 15px 20px;
}

.imageback {
  height: 30px;
  width: auto;
}

.no_touch {
  pointer-events: none;
}

.wrap {
  border: 1px solid #ffffff;
  border-radius: 13px;
  padding: 25px 15px;
  background: #ebebeb29;
  margin: 10px;
}

.title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  p {
    font-size: 18px;
    color: #000;
    font-weight: 400;
  }

  .cut {
    color: #ffffff;
    font-size: 14px;
    border: 1px solid #ffffff;
    padding: 4px;
    border-radius: 5px;
    width: fit-content;
    text-align: center;
    background-color: #247575;
  }
}

.bd_tel {
  margin-top: 23px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
}

.eye_bi {
  width: 21px;
  height: 25px;
  background: url(../images/user/eye2.png) no-repeat center center;
  background-size: 100% auto;
  margin-right: 10px !important;

  &.eye {
    background: url(../images/user/eye1.png) no-repeat center center;
    background-size: 100% auto;
  }
}

.confirm_btn.no_touch {
  color: rgba(255, 255, 255, 0.5);
}

.confirm_btn {
  height: 50px;
  line-height: 46px;
  font-size: 24px;
  width: 100%;
  border-radius: 15px;
  color: #ffffff;
  text-align: center;
  border: 1px solid #ffffff;
  margin-top: 60px;
  background: linear-gradient(
    117deg,
    rgba(254, 166, 0, 1) 0%,
    rgba(255, 188, 0, 1) 100%
  );
}

.labelText {
  color: #ffffff;
  padding: 4px 10px;
  font-size: 14px;
}

.item {
  height: 46px;
  border: 1px solid #ffffff;
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding-bottom: 9px;
  border-radius: 20px;
  background: #d4dddfde;
  .icon {
    width: 70px;
    height: 27px;
    padding-left: 10px;
    display: flex;
    align-items: center;
    img {
      width: 27px;
      height: 27px;
    }
  }
  input {
    height: 20px;
    margin-left: 7px;
    flex: 1;
    margin-bottom: 3px;
  }
}

.get_code {
  height: 38px;
  line-height: 48px;
  font-size: 12px;
  color: #247575;
  margin-right: 10px;
  font-weight: 700;
}
</style>
